import { ref, Ref } from 'vue';
/**
 * 创建分页请求
 */
type RequestFunc = (...args: Array<any>) => Promise<any>;
type CreateConfig = { waitTime?: number; timeOut?: number };
type RequestConfig = { data?: Object; error?: any };
type ReturnFunc = (config: RequestConfig, init: boolean) => Promise<any>;
type ReturnType = [ReturnFunc, Ref<boolean>, Ref<boolean>];
/**
 * 创建分页请求
 */
export function createPagination(func: RequestFunc, config?: CreateConfig): ReturnType {
    const { waitTime = 0, timeOut = 200 } = config || {};
    const disabled = ref(false);
    const loading = ref(false);
    let page = 1;

    const DELAY = 50;

    const request: ReturnFunc = ({ data, error }, flag = false) => {
        if (flag) {
            page = 1;
        }
        const start = Date.now();
        let timer: NodeJS.Timeout;
        if (timeOut) {
            timer = setTimeout(() => {
                loading.value = true;
            }, timeOut);
        } else {
            loading.value = true;
        }
        return func({ ...data, page: page++ }, error)
            .then((res) => {
                disabled.value = res.current_page >= res.last_page;
                return res;
            })
            .finally(() => {
                // 根据是否给出超时时间判断关闭loading的逻辑
                if (timeOut) {
                    const now = Date.now();
                    const usedTime = now - start;
                    if (usedTime >= timeOut) {
                        setTimeout(() => {
                            loading.value = false;
                        }, waitTime + DELAY - (usedTime - timeOut));
                    } else {
                        setTimeout(() => {
                            loading.value = false;
                        }, DELAY);
                        clearTimeout(timer);
                    }
                } else {
                    setTimeout(() => {
                        loading.value = false;
                    }, start + DELAY + waitTime - Date.now());
                }
            });
    };

    return [request, disabled, loading];
}
